import React from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const PROFILES = [
  {
    href: "https://www.linkedin.com/company/virpluz/home/",
    label: "LinkedIn",
    Icon: FaLinkedinIn,
  },
  {
    href: "https://www.instagram.com/virpluz",
    label: "Instagram",
    Icon: FaInstagram,
  },
];

const SocialLinks = () => {
  const { t } = useTranslation();

  return (
    <nav className="social-links" aria-label={t("social.label")}>
      {PROFILES.map((profile) => (
        <a
          key={profile.label}
          href={profile.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${profile.label} (${t("social.newTab")})`}
        >
          <profile.Icon aria-hidden="true" />
        </a>
      ))}
    </nav>
  );
};

export default SocialLinks;
